import { createAtomState } from '@/ui/utilities/state/jotai/utils/createAtomState';

export const isMobileNavigationDrawerOpenState = createAtomState<boolean>({
  key: 'isMobileNavigationDrawerOpenState',
  defaultValue: false,
});
